import { PublicationType } from '@colibrio/colibrio-reader-framework/colibrio-core-publication-base';
import { ILocator, Locator } from '@colibrio/colibrio-reader-framework/colibrio-core-locator';
import { IReaderPublication, IReaderView } from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-base';
import { IEpubReaderPublication } from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub';
import type { IPdfReaderPublication } from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-pdf';

import { epubCfiSelectorFactory } from './epubcfi-selector-factory';

export function getPublicationTypeFromPublication(publication: IReaderPublication) {
  return publication.getSourcePublication().getType();
}

export function isEpubPublication(publication: IReaderPublication): publication is IEpubReaderPublication {
  return getPublicationTypeFromPublication(publication) === PublicationType.EPUB;
}

export function isPdfPublication(publication: IReaderPublication): publication is IPdfReaderPublication {
  return getPublicationTypeFromPublication(publication) === PublicationType.PDF;
}

export const getLocatorFromEpubCfi = (publicationUrl: string, epubCfi: string) => {
  const selector = epubCfiSelectorFactory.createFromFragment(epubCfi);

  if (!selector) return;

  return new Locator(publicationUrl, [selector]);
};

export const getPublicationUrl = (readerView: IReaderView) => {
  return readerView.getReaderPublications()[0]?.getDefaultLocatorUrl();
};

export const getEpubCfiFromLocator = (locator: ILocator) => {
  const selectors = locator.getSelectors();

  if (!selectors.length) return;

  return selectors[0].toString();
};

export const getContentLocation = (readerView: IReaderView, locator: ILocator) => {
  return readerView.getReaderPublications()[0]?.fetchContentLocation(locator);
};
